var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styles from './style.module.css';
import { Modal } from '../../../Components/Modals/Modal';
import { Button } from '../../../Components/BaseComponents/Button';
import { Caption } from '../../../Components/Footer/Caption';
var Steps;
(function (Steps) {
    Steps[Steps["First"] = 0] = "First";
    Steps[Steps["Second"] = 1] = "Second";
    Steps[Steps["Third"] = 2] = "Third";
})(Steps || (Steps = {}));
var config = (_a = {},
    _a[Steps.First] = {
        label: 'Simplified Account Management',
        text: 'Pass the KYC procedure once and easily interact with digital platforms in one click.',
        img: './public/asset/zero_id_info_modal/steps/pic_step_1.png',
        alt: 'Step №1',
        btnLabel: 'Next',
    },
    _a[Steps.Second] = {
        label: 'Enhanced Security and Privacy',
        text: 'Your personal data is encrypted and access to it is controlled only by you.',
        img: './public/asset/zero_id_info_modal/steps/pic_step_2.png',
        alt: 'Step №2',
        btnLabel: 'Next',
    },
    _a[Steps.Third] = {
        label: 'Verify your Identity Privately',
        text: 'Prove that you are a real and unique person without sharing personal data.',
        img: './public/asset/zero_id_info_modal/steps/pic_step_3.png',
        alt: 'Step №3',
        btnLabel: 'Close',
    },
    _a);
export function InformationModal(_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose;
    var _b = React.useState(Steps.First), step = _b[0], setStep = _b[1];
    var handleClose = function () {
        onClose();
        setStep(Steps.First);
    };
    return (_jsx(Modal, __assign({ label: "Swipelux ZeroId", isOpen: isOpen, onClose: handleClose }, { children: _jsxs("div", __assign({ className: styles.modal_body_wrapper }, { children: [_jsx("div", __assign({ className: styles.modal_main_text }, { children: config[step].label })), _jsx("div", __assign({ className: styles.modal_text }, { children: config[step].text })), _jsx("img", { alt: config[step].alt, className: styles.modal_img, src: config[step].img }), _jsx("div", __assign({ className: styles.step_wrapper }, { children: Object.keys(Steps)
                        .map(Number)
                        .filter(function (e) { return !isNaN(e); })
                        .map(function (item, index) {
                        var isActive = index === step;
                        var className = isActive
                            ? "".concat(styles.step_item, " ").concat(styles.active)
                            : "".concat(styles.step_item);
                        return _jsx("div", { className: className }, index);
                    }) })), _jsx(Button, { className: styles.modal_btn, label: config[step].btnLabel, onClick: step !== Steps.Third ? function () { return setStep(step + 1); } : handleClose }), _jsx(Caption, {})] })) })));
}
